export default __webpack_public_path__ + "static/media/presentation.4dd88e9d.png";